var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-org-indicator",on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/admin')}}},[_c('organisation-thumbnail',{attrs:{"tenant-id":_vm.tenantId,"org-id":_vm.selectedOrganisation.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }